import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "../style/services-usa/shopify-web-development/_services.scss";

function ShopifyServices() {
  return (
    <section className="why_choose_unity shopify-services p-100 overflow-x-hidden">
      <Container>
        <Row className="justify-content-between">
          <Col xs={12} md={7} lg={7} xl={6} xxl={6} className="">
            <h2>
              Premium <span>Shopify Website Development</span> Services for
              Custom and Scalable Stores
            </h2>
          </Col>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5}>
            <p>
              Achieve a dominant position in the e-commerce market with our
              top-tier Shopify website development services, utilizing
              customized methods that deliver tangible results for your
              business.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-5">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="why-choose-box">
              <div className="icon">
                <div className="num">01</div>
                <h5>Shopify Development & Design</h5>
              </div>
              <div className="why-choose-content">
                <p>
                  We create customized Shopify stores that fulfill the brand's
                  aesthetic and technical requirements while increasing sales.
                  Being a leading Shopify website development company, we use
                  custom themes, integrated solutions, flexible layouts, and
                  advanced functionality to significantly enhance user
                  engagement and drive increased sales.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="why-choose-box">
              <div className="icon">
                <div className="num">02</div>
                <h5>Theme <br className="d-md-block d-none" />Customization</h5>
              </div>
              <div className="why-choose-content">
                <p>
                  We focus on theme customization to help your Shopify store
                  stand out from the crowd. Our experienced designers &
                  developers work with you to ensure that every part of your
                  theme aligns with your brand and business goals. We craft
                  flexible, original, and eye-catching web designs for a
                  standout first impression.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="why-choose-box">
              <div className="icon">
                <div className="num">03</div>
                <h5>App <br className="d-md-block d-none" />Integrations</h5>
              </div>
              <div className="why-choose-content">
                <p>
                  Adding apps to your site is easy, but ensuring they align with
                  your theme can be tricky. Our Shopify experts quickly resolve
                  any issues or create custom solutions for a seamless fit. We
                  enhance your store's features and deliver a robust, integrated
                  solution that boosts your business while keeping your site
                  running smoothly.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-xl-0 mb-4">
            <div className="why-choose-box">
              <div className="icon">
                <div className="num">04</div>
                <h5>Shopify Store Setup Services</h5>
              </div>
              <div className="why-choose-content">
                <p>
                  As a leading Shopify web development company, we know how to
                  set up your Shopify site with care and sanity. From theme
                  integration to putting up the necessary features and payment
                  choices, to creating a site that is both aesthetically
                  beautiful and successful in reaching goals, we’ve got you
                  covered.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-md-0 mb-4">
            <div className="why-choose-box">
              <div className="icon">
                <div className="num">05</div>
                <h5>Shopify Migration <br className="d-md-block d-none" />Services</h5>
              </div>
              <div className="why-choose-content">
                <p>
                  TekRevol offers Shopify migration services to help you
                  effortlessly transition your Shopify store from other
                  platforms including BigCommerce, Magento, WooCommerce, and
                  others. We handle the migration process personally, ensuring
                  all data, customer details, and purchase histories are
                  transferred safely and without loss.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="why-choose-box">
              <div className="icon">
                <div className="num">06</div>
                <h5>Ongoing <br className="d-md-block d-none" />Support</h5>
              </div>
              <div className="why-choose-content">
                <p>
                  Once the website is operational, the work does not end there.
                  TekRevol provides ongoing maintenance and enhancements to
                  maintain your Shopify store's success. Our support team is
                  here to handle backend maintenance, troubleshooting,
                  performance, and new feature optimization, ensuring your store
                  runs smoothly.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ShopifyServices;
